'use strict';

require('jquery');

/**
 * Closes all opened .dropdown--js menus except the one related to $current
 * @param  {Object} $current The checkbox that belongs to the dropdown we are
 *                           opening. It needs to stay open. (Optional)
 */
var closeDDs = function closeDDs($current) {

  // If we have a given $current
  if ($current) {

    // Loops through all the opened .dropdown--js dropdowns
    // and close their menu, only if there are not the one belonging to $current.
    $(".dropdown--js input:checked").each(function () {

      if (this !== $current) {
        $(this).prop('checked', false);
      }
    });
  }

  // Otherwise close all the opened  .dropdown--js dropdowns.
  // (i.e. when we click outside dropdowns).
  else {

      $(".dropdown--js input:checked").prop('checked', false);
    }
};

/**
 * Self executing function to init the dropdrowns.
 */
(function () {

  $(function () {

    var $dropdowns = $('.dropdown--js');

    if ($dropdowns.length > 0) {

      // On any dropdown--js click event
      $('.dropdown--js').on('click', 'label', function (e) {

        if (e.target.tagName !== 'A') {

          var $currentDD = $(e.target).closest(".dropdown--js");
          var $currentDDcheckbox = $currentDD.find('input[type="checkbox"]');

          // Removes event and avoid propagating to child element click events
          // (i.e. to the input click event...).
          e.preventDefault();
          e.stopPropagation();

          // Closes all .dropdown--js except the current one.
          closeDDs($currentDDcheckbox[0]);

          // If the .dropdown--js is not opened yet => opens it.
          if ($currentDDcheckbox.prop("checked") === false) {

            $currentDDcheckbox.prop('checked', true);
          }
          // else closes it.
          else {

              $currentDDcheckbox.prop('checked', false);
            }
        }
      });

      // On any click event, except on dropdown--js click event that already been
      // caught => close all opened dropdown--js.
      $(document).bind('click', function (e) {

        closeDDs();
      });
    }
  });
})();